import { TagTestStepReportComponent } from './tag-test-step-report/tag-test-step-report.component';
import { TagTestcaseReportComponent } from './tag-testcase-report/tag-testcase-report.component';
import { TagReportComponent } from './tag-report/tag-report.component';
import { ProjectSummaryReportComponent } from './project-summary-report/project-summary-report.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HistoryComponent } from '../test/history/history.component';
import { LatestReportComponent } from './latest-report/latest-report.component';
import { ManageConsoleExecutionComponent } from './manage-console-execution/manage-console-execution.component';
import { ReportComponent } from './report.component';
import { SuiteReportComponent } from './suite-report/suite-report.component';
import { TestResultSummaryComponent } from './test-result-summary/test-result-summary.component';
import { TestRunDetailComponent } from './test-run-detail/test-run-detail.component';
import { AuthCheck } from '../auth/auth.check';


const routes: Routes = [
  {
    path: 'testReport/:pid/:value', component: LatestReportComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'suiteReport/:pid/:suiteId', component: SuiteReportComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'projectTagReport/:pid', component: TagReportComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'tagTestCaseReport/:pid/:reportid', component: TagTestcaseReportComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'tagTestStepReport/:pid/:reportid/:testDataId/:dataIterationIndex/:path', component: TagTestStepReportComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'project-report/:pid', component: ReportComponent
    ,canActivate:[AuthCheck]},
  
  {
    path: 'manageConsoleExecution/:pid', component: ManageConsoleExecutionComponent

    ,canActivate:[AuthCheck]},
  {
    path: 'testCaseReport/:pid/:reportId/:testDataId/:path/:title/:iteration/:status', component: TestResultSummaryComponent
    ,canActivate:[AuthCheck]},

  {
    path: 'testStepReport/:pid/:reportId/:testDataId/:path/:title/:iteration/:status', component: TestRunDetailComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'projectSummaryReport/:pid/:starDate/:endDate/:os/:searchBrowser/:status', component: ProjectSummaryReportComponent
    ,canActivate:[AuthCheck]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }
